import React from 'react'
import { Loader } from './Loader'
import { PaginationLoader } from './PaginationLoader'
import fetchesNoteChildrenNotes from './dataSync/fetchesNoteChildrenNotes'
import fetchesChannelNotes from './dataSync/fetchesChannelNotes'
import fetchesAllTemplateNotes from './dataSync/fetchesAllTemplateNotes'
import fetchesArchivedNotes from './dataSync/fetchesArchivedNotes'
import fetchesAllBookmarkedNotes from './dataSync/fetchesAllBookmarkedNotes'

export const BookmarkedNotesLoader = fetchesAllBookmarkedNotes()(function({
  forceQuery,
}) {
  return <Loader load={forceQuery} />
})
export const TemplateNotesLoader = fetchesAllTemplateNotes()(PaginationLoader)
export const ArchivedNotesLoader = fetchesArchivedNotes()(PaginationLoader)
export const NoteChildrenLoader = fetchesNoteChildrenNotes()(PaginationLoader)
export const ChannelNotesLoader = fetchesChannelNotes()(PaginationLoader)
